import { UserLoginDataType } from "../../shared/context-api/actions";
import { initialStateType } from "../../shared/context-api/provider";



export const HasWriteAccess = (userData: UserLoginDataType) => {
    var userDataState = userData as initialStateType;
    return userDataState && userDataState.userData && userDataState.userData.userPermissions && userDataState.userData.userPermissions.lwaWriteAccess;
}